export default __webpack_public_path__ + "static/media/IvyMode-Bold.04e3d9cc.woff2";